import { Directive, Input, ElementRef, TemplateRef, ViewContainerRef, HostListener, Output, EventEmitter, OnInit, Renderer2 } from '@angular/core';

import { AppService } from 'src/app/app.service';
declare const $: any;
declare const window: Window;
import * as _ from 'lodash';

@Directive({
    selector: '[scrollSpy]',
    standalone: false
})
export class ScrollSpyDirective {
	@Input() public spiedTags = [];
	@Input() public spyOffset = 0;
	@Output() public sectionChange = new EventEmitter<string>();
	private currentSection: string;

	constructor(private _el: ElementRef) { }

	@HostListener('scroll', ['$event'])
	onScroll(event: any) {
		let currentSection: string;
		const children = this._el.nativeElement.children;
		const scrollTop = event.target.scrollTop;
		const parentOffset = event.target.offsetTop + this.spyOffset;
		for (let i = 0; i < children.length; i++) {
			const element = children[i];
			if (this.spiedTags.some(spiedTag => spiedTag === element.tagName)) {
				if ((element.offsetTop - parentOffset) <= scrollTop) {
					currentSection = element.id;
				}
			}
		}
		if (currentSection !== this.currentSection) {
			this.currentSection = currentSection;

			//if (this.currentSection) {
			//	const hSection = document.getElementById(this.currentSection);
			//	const hParent = document.getElementById('main-tab-scroll-content');
			//	console.log(hSection.offsetTop, Math.round(hParent.scrollTop), hSection.offsetTop - Math.round(hParent.scrollTop) );
			//}			

			this.sectionChange.emit(this.currentSection);
		}
	}
}


@Directive({
    selector: '[appImageSrc]',
    standalone: false
})

export class ImageSrcDirective implements OnInit {
	@Input('defaultImage') public defaultImageUrl: string;
	@Input('appImageSrc') public imageURL: string;
	@Input('expand') public expand: boolean;
	@Input() public model: any = {};

	constructor(
		private appService: AppService,
		private el: ElementRef
	) {
	}

	ngOnInit() {
		this.setImage();
	}

	setImage() {
		let el = this.el.nativeElement;
		let imageURL = this.imageURL;
		var defaultImage = this.defaultImageUrl || this.appService.images.meal;
		//if (bgImage) console.debug(bgImage);
		let _model = this.model || {};

		if (!imageURL || _model.$$noimage) {
			el.src = defaultImage;
			el.classList.add("no-image");
			_model.$$noimage = true;
		} else {
			if (_model.iconImage) el.classList.add("no-image");
			el.src = imageURL;
		}

		el.onerror = function () {
			el.src = defaultImage;
			el.classList.add("no-image");
			_model.$$noimage = true;
			_model.$$noimageerror = true;
		}

	}
}



@Directive({
    selector: '[appBgImage]',
    standalone: false
})

export class BgImageDirective implements OnInit {
	@Input('defaultImage') public defaultImageUrl: string;
	@Input('appBgImage') public bgImageUrl: string;
	@Input('expand') public expand: boolean;
	@Input() public model: any = {};

	constructor(
		private appService: AppService,
		private el: ElementRef
	) {
	}

	ngOnInit() {
		this.setImage()
	}

	setImage() {
		let el = $(this.el.nativeElement);
		var bgImage = this.bgImageUrl;
		var defaultImage = this.defaultImageUrl || this.appService.images.meal;
		//if (bgImage) console.debug(bgImage);
		let _model = this.model || {};

		if (this.expand) {
			let pxHeight = _model.enlargedImageHeight;
			if (!pxHeight) pxHeight = _.get(_model, 'cardStyle.pxHeight', 220) * 3;
			el.css("height", `${pxHeight}px`);
		}

		if (!bgImage || _model.$$noimage) {
			el.css("background-image", "url(" + defaultImage + ")");
			el.addClass("no-image");
			_model.$$noimage = true;
		} else {
			var image = new Image();
			image.src = bgImage;
			if (_model.iconImage) el.addClass("no-image");
			if (bgImage == 'images/meal-icon.svg') {
				el.css("background-image", "url(" + bgImage + ")");
				el.addClass("no-image");
				return;
			}
			image.onload = function () {
				//Image loaded- set the background image to it
				el.css("background-image", "url(" + bgImage + ")");
			};
			image.onerror = function () {
				//Image failed to load- use default
				el.css("background-image", "url(" + defaultImage + ")");
				el.addClass("no-image");
				_model.$$noimage = true;
			};
		}
	}
}

